<template>
  <div>
    <DatesBlock class="mb-3">
      <template #actions>
        <TeacherTileToggler
          class="ml-10 flex h-fit"
          :icons="['tile', 'list']"
          :active-tile="activeIndexTile"
          @change-group="handleActiveTile"
        />
      </template>
      <template #content>
        <!-- Временно скрыта -->
        <BaseTheSortedLine
          :data="categories"
          :selected-item="activeSort"
          @update:selected-item="handleActiveSort"
        />
        <div class="mt-8 grid gap-8">
          <div class="-m-2.5 flex flex-wrap">
            <NuxtLink
              v-for="item in dates"
              :key="item"
              :class="[
                activeTile === 'tile'
                  ? 'w-full p-2.5 md:w-1/2 lg:w-1/3 2xl:w-1/5'
                  : 'w-full max-w-[963px] p-2',
              ]"
              :to="{
                name: 'teacher-historical-calendar-slug',
                params: {
                  slug: item.slug,
                },
              }"
            >
              <CardsDateCard :is-tile="activeTile === 'tile'" :data="item" />
            </NuxtLink>
          </div>
          <div v-if="totalPages > 1" class="grid w-fit grid-flow-col gap-2.5">
            <NuxtLink
              :key="`${totalPages}-last`"
              class="grid w-fit min-w-[32px] cursor-pointer place-content-center"
              :to="{
                query: {
                  ...route.query,
                  page: Math.max(Number(route.query.page || 1) - 1, 1),
                },
              }"
              :class="{ disabled: page === 1 }"
            >
              <SlidersSliderControl type="prev"
            /></NuxtLink>
            <BaseThePagination
              :paginate-pages="paginatePages"
              :total-pages="totalPages"
              :page="page"
              :view-page="viewPage"
              :offset="OFFSET"
            />
            <NuxtLink
              :key="`${totalPages}-last`"
              class="grid w-fit min-w-[32px] cursor-pointer place-content-center"
              :to="{
                query: {
                  ...route.query,
                  page: Number(route.query.page || 1) + 1,
                },
              }"
              :class="{ disabled: page >= totalPages }"
            >
              <SlidersSliderControl type="next"
            /></NuxtLink>
          </div>
        </div>
      </template>
    </DatesBlock>
  </div>
</template>

<script setup>
const route = useRoute();
const router = useRouter();

/**paginatePages */
const OFFSET = 1;

const page = computed(() => Number(route.query?.page) || 1);

const viewPage = ref(page.value);

const days = computed(() => {
  const dateString =
    route.query?.days ||
    new Array(2)
      .fill(
        new Date().toLocaleDateString('ru-RU', {
          day: 'numeric',
          month: '2-digit',
        }),
      )
      .join('-');

  if (!dateString) {
    return null;
  }

  if (dateString.includes('-')) {
    const [start, end] = dateString.split('-');
    const startParts = start.split('.');
    const endParts = end.split('.');
    return {
      start_day: startParts[0],
      start_month: Number(startParts[1]),
      end_day: endParts[0],
      end_month: Number(endParts[1]),
    };
  } else {
    const parts = dateString.split('.');
    return {
      start_day: parts[0],
      start_month: Number(parts[1]),
      end_day: parts[0],
      end_month: Number(parts[1]),
    };
  }
});

/** GET DATA */
// const { datesCategories } = useDatesCategories();
const categories = computed(() => [
  { title: 'Все', id: null },
  // ...(datesCategories.data?.value || []),
]);

const filters = computed(() => {
  return {
    category: route.query?.sort,
    ...(days.value && { ...days.value }),
  };
});

const { dateArticles } = useDateArticles({
  filters,
  page,
  per_page: 15,
});

watch(filters, () =>
  router.replace({ query: { ...route.query, page: undefined } }),
);

const dates = computed(() => dateArticles?.data?.value?.data || []);

/**paginatePages CONTINUE*/
const totalPages = computed(
  () => dateArticles?.data?.value?.meta?.last_page ?? 0,
);

const paginatePages = computed(() => {
  const arr = [];
  for (
    let i = Math.max(page.value - OFFSET, 1);
    i <= Math.min(page.value + OFFSET, totalPages.value);
    i++
  ) {
    arr.push(i);
  }
  return arr;
});

/** SORTING */
const activeSort = computed(() => {
  return Number(route.query.sort) || 0;
});

const handleActiveSort = (id) => {
  if (id === activeSort.value) return;

  router.replace({
    query: {
      ...route.query,
      sort: id ? id : undefined,
    },
  });
};

/** GROUP List */
const groupList = computed(() => {
  return ['tile', 'list'];
});

const activeTile = computed(() => {
  return route.query.group || 'tile';
});

const activeIndexTile = computed(() => {
  return groupList.value?.findIndex((g) => g === activeTile.value);
});

const handleActiveTile = (idx) => {
  if (idx === activeIndexTile.value) return;

  router.replace({
    query: {
      ...route.query,
      group: idx ? groupList.value[idx] : undefined,
    },
  });
};
</script>

<style lang="scss" scoped>
.disabled {
  @apply pointer-events-none opacity-50;
}
</style>
